export const HEADER_BLOCK_S16 = {
  "temp":{
    "templateId":16
  },
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "SOLUTIONS",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "4px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.125rem",
          "line-height": "1.75rem",
          "font-weight": "600",
          "font-family-cust": "",
          "font-family": "",
          "background-color": "#ffffff",
          "padding": "5px 20px 5px 0px",
          "border-radius": "9999px",
          "border-color": "",
          "border-width": "0px"
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "0px 0px 0px 0px",
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsMob": {
          "font-size": "1rem",
          "line-height": "1.5rem"
        },
        "stylePropsTab": {
          "font-size": "1rem",
          "line-height": "1.5rem"
        }
      },
      {
        "text": "Transforming Businesses with Innovative Software Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "2.25rem",
          "line-height": "2.5rem",
          "font-family": "'Source Serif 4'",
          "font-weight": "500",
          "font-family-cust": "Source Serif 4",
          "font-family-bk": "'Source Serif 4', cursive"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "1.875rem",
          "line-height": "2.25rem"
        },
        "stylePropsTab": {
          "font-size": "2.25rem",
          "line-height": "2.5rem"
        }
      },
      {
        "text": "Custom Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.25rem",
          "line-height": "1.75rem",
          "font-weight": "700"
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "10px 0px 10px 0px",
          "padding": "30px 0px 10px 20px"
        }
      },
      {
        "text": "Tailored software solutions designed to meet your unique business needs and goals.",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 220px 0px 20px"
        },
        "alignStylePropsTab": {
          "padding": "0px 20px 0px 20px"
        },
        "alignStylePropsMob": {
          "padding": "1px 20px 0px 20px"
        }
      },
      {
        "text": "Expert Guidance",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.25rem",
          "line-height": "1.75rem",
          "font-weight": "700"
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "10px 0px 10px 0px",
          "padding": "30px 0px 10px 20px"
        }
      },
      {
        "text": "Our team of experienced professionals provides expert guidance and support to ensure your success.",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 220px 0px 20px"
        },
        "alignStylePropsTab": {
          "padding": "0px 20px 0px 20px"
        },
        "alignStylePropsMob": {
          "padding": "0px 20px 40px 20px"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 10px"
    },
    "buttonAlign": "start",
    "buttons": [],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    }
  },
  "imageType": "image",
  "imageVideoPostion": "left",
  "imageBlock": {
    "image": "https://images.pexels.com/photos/7552715/pexels-photo-7552715.jpeg?auto=compress&cs=tinysrgb&w=600",
    "styleProps": {
      "margin": "0px 0px 0px 0px",
      "border-radius": "0px",
      "background-color": "",
      "box-shadow": "",
      "border-width": "0px"
    },
    "imageTag": {
      "styleProps": {
        "border-radius": "1.5rem"
      }
    },
    "tagStyleProps": {
      "border-radius": "1.5rem",
      "border-width": "0px",
      "border-color": "#ffa611",
      "box-shadow": ""
    },
    "outerStyleProps": {
      "box-shadow": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "border-radius": "1.5rem",
      "background-color": ""
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1745700106974,
  "afterIndex": 0,
  "blockId": 1745700106974,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": "Source Serif 4"
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}